import api from "../../utils/api";
import { API_CONFIG } from '../../utils/apiConfig';

const getLinkedDevices = async () => {
  try {
    const response = await api.get(API_CONFIG.SETTINGS.LINKED_DEVICES);
    const data = response.data;
    if (data.success) {
      return {
        success: true,
        devices: data.data,
        count: data.count
      };
    } else {
      return {
        success: false,
        error: data.error || 'Failed to fetch devices'
      };
    }
  } catch (error) {
    console.error('Error fetching linked devices:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Network error occurred'
    };
  }
};

export default getLinkedDevices;